import { Component, ElementRef, Input, PLATFORM_ID, inject } from '@angular/core';
import { NormalNavbar } from "../../layout/normal-navbar/normal-navbar";
import { trigger, transition, style, animate } from '@angular/animations';
import { TvDetails } from "./components/tv-details/tv-details.component";
import { TvAccounts } from './components/tv-accounts/tv-accounts.component';
import { TvCredits } from './components/tv-credits/tv-credits.component';
import { TvRecommendations } from './components/tv-recommendations/tv-recommendations.component';
import { TvSimilar } from './components/tv-similar/tv-similar.module';
import { SeasonStatus } from './components/seasons/season-status/season-status.component';
import { Footer } from '../../layout/footer/footer.component';
import { TvFacts } from "./components/tv-facts/tv-facts";
import { ViewChild } from '@angular/core';
import { YoutubePlayerService } from '../../core/services/youtube.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-tv',
  imports: [
    CommonModule,
    NormalNavbar,
    TvDetails,
    TvCredits,
    TvAccounts,
    TvRecommendations,
    TvSimilar,
    SeasonStatus,
    Footer,
    TvFacts
  ],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 }))
      ])
    ])
  ],
  templateUrl: './tv.html',
  styleUrl: './tv.scss'
})

export class TVShow {

  @ViewChild('TrailerContainer') trailerContainer!:ElementRef<HTMLDivElement>
  showPlayer: boolean = false;
  private readonly platformId = inject(PLATFORM_ID);

  trailerContainerDiv?: ElementRef<HTMLDivElement>;
  constructor(
    private youtubeService: YoutubePlayerService
  ){
    
  }

  ngAfterViewInit() {
    this.trailerContainerDiv = this.trailerContainer;
  }

  closeTrailer(): void {
    this.showPlayer = false;
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.overflow = '';
    }
    
    // Destroy the YouTube player to stop playback
    if (this.youtubeService) {
      this.youtubeService.destroyPlayer();
    }
  }
}
